import * as React from 'react';

const alertRef = React.createRef(null);

export default alertRef;
